module.exports = __webpack_public_path__ + "img/six.34213b4a.png";